module.exports = __webpack_public_path__ + "static/media/ev-4.3d7f14a8.jpg";